import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const HomeContainer = () => (
  <div>
    {/* Главный баннер */}
    <section
      className="banner text-center py-5"
      style={{
        backgroundImage: 'url("/images/main-banner.jpg")',
        backgroundSize: "cover",
        color: "#FFFFFF",
        backgroundColor: "#E87400",
      }}
    >
      <div className="container">
        <h1 className="display-4">Empowering Global Travel Solutions</h1>
        <p className="lead">
          Unrivaled corporate travel and meetings services. Anytime, anywhere.
        </p>
        <Link to="/contact" className="btn btn-lg btn-light mt-3">
          Let’s Talk
        </Link>
      </div>
    </section>

    {/* Наши услуги */}
    <section className="services py-5" style={{ backgroundColor: "#F8F9FA" }}>
      <div className="container text-center">
        <h2 className="mb-4">Business Travel Solutions</h2>
        <div className="row">
          {[
            {
              icon: "plane",
              title: "Air Travel",
              text: "Secure the best rates for corporate flights.",
            },
            {
              icon: "building",
              title: "Accommodation",
              text: "Access over 1M hotels worldwide.",
            },
            {
              icon: "event",
              title: "Meetings & Events",
              text: "Expert event management anywhere.",
            },
            {
              icon: "car",
              title: "Ground Transport",
              text: "Reliable transport solutions worldwide.",
            },
            {
              icon: "handshake",
              title: "Consulting",
              text: "Customized travel strategies for growth.",
            },
            {
              icon: "eco",
              title: "Sustainability",
              text: "Support for eco-friendly travel practices.",
            },
          ].map((service, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <i
                className={`fa fa-${service.icon} fa-3x mb-3 text-secondary`}
              />
              <h4>{service.title}</h4>
              <p>{service.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* О нас */}
    <section className="about-us py-5" style={{ backgroundColor: "#FFFFFF" }}>
      <div className="container text-center">
        <h2>About Our Platform</h2>
        <p className="lead">
          We offer corporate travel solutions that keep your employees engaged,
          connected, and safe on the go.
        </p>
        <p>
          Leveraging cutting-edge technology, data insights, and a vast global
          network, we streamline every aspect of travel and events management.
        </p>
      </div>
    </section>

    {/* Преимущества для бизнеса */}
    <section
      className="business-benefits py-5"
      style={{ backgroundColor: "#F0F2F5" }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h2>Why Partner with Us?</h2>
            <p>
              Empower your business with data-driven strategies and seamless
              travel management solutions that align with your goals.
            </p>
            <ul>
              <li>Comprehensive travel and meetings management</li>
              <li>Global data analytics for actionable insights</li>
              <li>Reliable, real-time support across all time zones</li>
              <li>Customized solutions tailored to your industry</li>
            </ul>
            <Link to="/register" className="btn btn-lg btn-warning mt-3">
              Explore Our Services
            </Link>
          </div>
          <div className="col-md-6">
            <img
              src="/images/business-benefits.webp"
              alt="Business Benefits"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Часто задаваемые вопросы */}
    <section className="faq py-5" style={{ backgroundColor: "#FFFFFF" }}>
      <div className="container">
        <h2 className="text-center mb-4">Frequently Asked Questions</h2>
        <div className="accordion" id="faqAccordion">
          {[
            {
              question: "What services does your platform offer?",
              answer:
                "We provide end-to-end travel and event management solutions tailored to your business needs.",
            },
            {
              question: "How do you ensure data security?",
              answer:
                "Our platform employs top-tier encryption and security protocols to protect all traveler data.",
            },
            {
              question: "Can I track employee travel expenses?",
              answer:
                "Yes, our business intelligence tools provide detailed analytics and expense tracking.",
            },
            {
              question: "Is support available 24/7?",
              answer:
                "Absolutely. Our support team is available around the clock to assist with any travel-related needs.",
            },
            {
              question: "Do you offer eco-friendly travel options?",
              answer:
                "Yes, we promote sustainable travel solutions and provide sustainability data for tracking.",
            },
            {
              question: "How can I get started?",
              answer:
                "Simply create an account, and our team will help you set up your travel program.",
            },
            {
              question: "Are your solutions scalable?",
              answer:
                "Yes, our solutions are designed to grow with your business, offering flexible, scalable options.",
            },
          ].map((faq, index) => (
            <div
              className="card"
              key={index}
              style={{ border: "none", marginBottom: "10px" }}
            >
              <div
                className="card-header"
                style={{
                  cursor: "pointer",
                  backgroundColor: "#E87400",
                  color: "#FFFFFF",
                  padding: "10px",
                }}
              >
                <h5 className="mb-0">{faq.question}</h5>
              </div>
              {
                <div
                  className="card-body"
                  style={{ backgroundColor: "#F8F9FA", color: "#333333" }}
                >
                  <p>{faq.answer}</p>
                </div>
              }
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/containers/home_container.js